import { DestinationEvent } from '@eventbrite/event-renderer';
import { sdkRequest } from '@eventbrite/http';
import { AggType } from '../constants/agg';
import { DateAggResponse, DateRange, DateType } from '../constants/dates';
import { PriceType } from '../constants/prices';
import { SortType } from '../constants/sort';
import { SearchServerEnrolledExperiments } from '../types/Experiments';

export function searchOrganicEvents(
    search: OrganicEventSearchApiPayload,
): Promise<OrganicEventSearchApiResponse> {
    // TODO: remove this workaround when server data query came without this field from SSR flow.
    (search as any).event_search.include_promoted_events_for = undefined;
    return sdkRequest('/api/v3/destination/search/', {
        method: 'POST',
        body: JSON.stringify(search),
    });
}

export interface OrganicEventSearchApiPayload {
    event_search: OrganicEventSearchFiltersApiPayload;
    'expand.destination_event'?: string[];
    'expand.destination_profile'?: string[];
}

export interface OrganicEventSearchFiltersApiPayload {
    dates?: DateType | DateType[];
    tags?: string[];
    price?: PriceType;
    q?: string;
    places?: string[];
    bbox?:
        | string
        | {
              sw: { lng: number; lat: number };
              ne: { lng: number; lat: number };
          };
    currencies?: any;
    dedup?: boolean;
    date_range?: DateRange;
    hash?: string;
    languages?: any;
    online_events_only?: boolean;
    organizations_or?: string[];
    page?: number;
    page_size?: number;
    search_id?: string;
    source?: any;
    special?: string[];
    point_radius?: any;
    client_timezone?: any;
    duration_range?: any;
    aggs?: AggType;
    continuation?: string;
    sort?: SortType;
    exclude?: {
        ids?: string[];
    };
    image?: boolean;
}

export interface OrganicEventSearchApiResponse {
    articles: {};
    current_user_id: string;
    profile_search: {};
    article_search: {};
    profiles: {};
    experiment_enrollment: SearchServerEnrolledExperiments;
    events: {
        pagination: {
            object_count: number;
            page_count: number;
            page_number: number;
            page_size: number;
            continuation: string;
        };
        results: DestinationEvent[];
        aggs?: {
            dates?: { buckets: DateAggResponse[] };
            tags?: { buckets: TagAggApiResponse[] };
            organizertagsautocomplete_agg?: {
                buckets: OrganizerAutocompleteAggApiResponse[];
            };
        };
        promoted_results: DestinationEvent[];
        top_match: DestinationEvent[];
    };
    is_staff: boolean;
    search_id: string;
    es: [];
    event_search: OrganicEventSearchFiltersApiPayload;
}

export interface TagAggApiResponse {
    inflated?: {
        prefix: string;
        tag: string;
        display_name: string;
    };
    display_name: string;
    key: string;
    doc_count?: number;
}

export interface OrganizerAutocompleteAggApiResponse {
    inflated: string;
    display_name: string;
    key: string;
    doc_count: number;
}
